/** Warms both chunks the modal needs. Hosts fire this and don't await it, so a failed warm stays quiet. */
const preloadPrint = () =>
  Promise.all([import('../components/PrintModal/PrintModal'), import('../components/PrintPreviewMap/PrintPreviewMap')]).catch(() => undefined);

export default preloadPrint;
